<script lang="ts">
  import { onMount, onDestroy, tick } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";

  export let lastSyncTime: string = "";
  export let globalHealth: string = "Healthy";
  export let healthIcon: string = "🟢";
  export let loading: boolean = false;
  export let isVisible: boolean = false;
  export let controlsDisabled: boolean = false;
  export let syncProgress: {
    current: number;
    total: number;
    message: string;
  } | null = null;
  export let syncActions: Array<{
    label: string;
    description: string;
    badgeClass: string;
    iconPaths: string[];
    handler: () => void;
  }> = [];

  export let onToggleVisibility: () => void = () => {};

  let container: HTMLDivElement;
  let instance: any = null;

  async function mount() {
    if (!container) return;

    try {
      // @ts-ignore - App2 remote
      const m = await import("App2/syncHeader");
      const Component = m.default;

      await tick();

      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container,
        props: {
          lastSyncTime,
          globalHealth,
          healthIcon,
          loading,
          isVisible,
          controlsDisabled,
          syncProgress,
          syncActions,
          title: "AcelinkHS – Opportunity Sync",
          onToggleVisibility,
        },
      });
    } catch (err) {
      console.warn("App2/syncHeader not available:", err);
    }
  }

  onMount(() => {
    mount();
  });

  $: if (instance) {
    instance.$set({
      lastSyncTime,
      globalHealth,
      healthIcon,
      loading,
      isVisible,
      controlsDisabled,
      syncProgress,
      syncActions,
      title: "AcelinkHS – Opportunity Sync",
      onToggleVisibility,
    });
  }

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div bind:this={container} data-sync-header-host></div>
